<template>
  <el-row class="bg">
    <img style="width: 100%; position:absolute;bottom: 0; left: 0;" src="../../assets/last.png" alt="">
    <el-button class='bacToIndex' size="mini" @click="backtoIndex">返回首页</el-button>
    <el-col :span='2' class='title'>
        <span style="color:#0068b4">政策</span>
        <span style="color:#001e69">导览</span>
    </el-col>
    <el-col :span='10' class='content'>
        <div class="items" v-for="(item, index) in list" :key="index" @click="activeThis(index)">
            <div style="margin-right: 70px; display: inline-block;">{{index + 1}}</div>
            
            <span>{{item.name}}</span>
        </div>
    </el-col>
    <el-col :span='12' class='intro'>
        <div class='boxPolicy'>
            <!-- <div v-if="index == index2" v-for="(item2, index2) in list" :key="index2" class='policyContent'>
                <el-collapse accordion v-model="activeCollapse">
                    <el-collapse-item v-for="(item3, index3) in item2.list" :key="index3" :title="item3.title" :name="1 + index3" @click="triggerClick">
                        <div v-html="item3.content"></div>
                    </el-collapse-item>
                </el-collapse>
            </div> -->
        <div v-if="index==0" class='policyContent'>
            <el-collapse accordion v-model="activeCollapse">
                <el-collapse-item title="（一）首次来太落户大创园的大学生创业项目直接给予5万元创业资助。" name="1">
                    <div>项目咨询电话：戴先生18962618966、王女士 15250594486；<br>
                        政策咨询电话：0512-53987080
                    </div>
                </el-collapse-item>
                <el-collapse-item title="（二）落户全国性大学生创新创业大赛获奖项目的，直接按照一等奖50万元、二等奖30万元、三等奖20万元给予创业资助。" name="2">
                    <div>
                        项目咨询电话：戴先生18962618966、王女士 15250594486；<br>
                        政策咨询电话：0512-53987080
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div v-if="index==1" class='policyContent'>
            <el-collapse accordion v-model="activeCollapse">
                <el-collapse-item title="（一）给予大创园新落户大学生创业项目3年场地免租。" name="1">
                    <div>
                        创业项目完成注册后，办理入园手续时，签订场地免租合同，咨询电话：0512-53987080
                    </div>
                </el-collapse-item>
                <el-collapse-item title="（二）录用首次在太就业高校毕业生的，缴纳社保满6个月，按每人3000元标准给予创业带动就业补贴。" name="2">
                    <div>
                        申报网址：<a class="linkCss" :href="JiuYeUrl">{{JiuYeUrl}}</a>; <br>
                        政策咨询电话：0512-53987080
                    </div>
                </el-collapse-item>
                <el-collapse-item title="（三）加大大学生创业空间供给，放宽经营场所登记限制，支持更多新业态大学生创业项目入驻。" name="3">
                    <div>
                       联系市行政审批局,前台电话0512-53890556;<br>
                       咨询电话：0512-53890525 、0512-53890526
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div v-if="index==2" class='policyContent'>
            <el-collapse accordion v-model="activeCollapse">
                <el-collapse-item title="（一）成立3亿元天使投资基金，择优给予落户大学生创业项目最高300万元股权投资。" name="1">
                    <div>近期推出相关产品</div>
                </el-collapse-item>
                <el-collapse-item title="（二）推出“娄城大学生创业贷”政府增信金融产品，提供风险补偿，单个项目贷款最高100万元。" name="2">
                    <div>
                       近期推出相关产品
                    </div>
                </el-collapse-item>
                <el-collapse-item title="（三）加大科技金融补助力度，对企业“苏科贷”“娄城科创贷”等贷款，按实际发放额的5‰给予最高50万元/年贴息补助。" name="3">                   
                    <div>
                        联系中信、宁波、光大银行办理
                    </div>
                </el-collapse-item>
                <el-collapse-item title="（四）对企业知识产权质押融资，按实际融资额的1%给予最高10万元奖励。" name="4">                   
                    <div>
                        联系市市监局咨询办理，电话：0512-53524715
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div v-if="index==3" class='policyContent'>
            <el-collapse accordion v-model="activeCollapse">
                <el-collapse-item title="（一）全日制本科及以上毕业生首次来太到大创园实地考察创新创业环境，可享受最高500元考察补贴。" name="1">
                    <div>“大创园创业专属考察礼遇”微信小程序上申请</div>
                </el-collapse-item>
                <el-collapse-item title="（二）全日制本科及以上毕业生首次来太到大创园实地考察创新创业环境，最长15天人才公寓免费住宿。" name="2">
                    <div>
                       “大创园创业专属考察礼遇”微信小程序上申请
                    </div>
                </el-collapse-item>
                <el-collapse-item title="（三）全日制本科及以上在校生在大创园企业见习的，给予1000元/月见习补贴。" name="3">                   
                    <div>
                        申报网址：<a class="linkCss" :href="JianXiUrl">{{JianXiUrl}}</a>; <br>
                        咨询电话：0512-53987080
                    </div>
                </el-collapse-item>
                <el-collapse-item title="（四）世界前300强高校或“双一流”建设高校（学科）毕业生首次来太入职大创园企业，缴纳社保满6个月，按本科3万元、硕士5万元、博士10万元给予“首年生活补贴”。" name="4">                   
                    <div class='indexBold'>办理方式</div>
                    <div>
                       登入太仓人才总入口，网址：<a class="linkCss" @click="toNewPage(2)">https://gccrc.tcrc.com.cn/#/</a>，选择“人才计划”再选择“青年人才首年生活补贴”进行申报，咨询电话：0512-53568578、0512-53987080
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div v-if="index==4" class='policyContent'>
            <el-collapse accordion v-model="activeCollapse">
                <el-collapse-item title="（一）园内企业与高校院所开展产学研合作的，按实际发生经费的20%给予最高50万元补助。" name="1">
                    <div class='indexBold'>办理方式</div>
                    <div>联系市科技局咨询办理，电话：0512-53595193</div>
                </el-collapse-item>
                <el-collapse-item title="（二）园内企业使用江苏省、苏州市科技创新券的，给予最高50万元资助。" name="2">
                    <div class='indexBold'>办理方式</div>
                    <div>
                        联系市科技局咨询办理，电话：0512-53595115
                    </div>
                </el-collapse-item>
                <el-collapse-item title="（三）加强知识产权创造激励，对成效明显的企业给予5万元一次性奖励。" name="3">                   
                    <div class='indexBold'>办理方式</div>
                    <div>
                       联系市市监局咨询办理，电话：0512-53524715
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div v-if="index==5" class='policyContent'>
            <el-collapse accordion v-model="activeCollapse">
                <el-collapse-item title="（一）依托太仓市企业服务总入口，建设大科园供需对接平台，帮助园内企业对接产业链上下游资源，支持优质成果在全市推广应用。" name="1">
                    <div class='indexBold'>办理方式</div>
                    <div>
                        办理平台网址：<a class="linkCss" @click="toNewPage(1)">http://www.taicangqyfw.com.cn/</a> <br>
                        太仓市企业服务中心咨询电话：0512-33001717
                    </div>
                </el-collapse-item>
                <el-collapse-item title="（二）园内企业参加国内外有较高影响力的展会，给予每个标准展位最高2万元，每家企业最高8万元补贴。" name="2">
                    <div class='indexBold'>办理方式</div>
                    <div>
                        联系高新区经发局咨询办理，电话：0512-53595056（国内展会）  <br> 
                        电话：0512-53595217（国外展会）
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div v-if="index==6" class='policyContent'>
            <el-collapse accordion v-model="activeCollapse">
                <el-collapse-item title="（一）对新认定为国家级、省级众创空间的，分别给予最高50万元、30万元奖励。" name="1">
                    <div class='indexBold'>办理方式</div>
                    <div>
                       联系市科技局咨询办理，电话：0512-53595115
                    </div>
                </el-collapse-item>
                <el-collapse-item title="（二）鼓励高校院所在大科园设立大学生创新创业实践基地，根据年度绩效任务完成情况，给予不少于30万元奖励。" name="2">
                    <div class='indexBold'>办理方式</div>
                    <div>
                        咨询电话：0512-53987080
                    </div>
                </el-collapse-item>
                <el-collapse-item title="（三）引才组织和个人引荐大学生创业项目入选市级以上领军人才计划的，按人才实缴资本5%给予最高100万元引才奖励。" name="3">
                    <div class='indexBold'>办理方式</div>
                    <div>
                        办理平台网址：<a class="linkCss" @click="toNewPage(1)">http://www.taicangqyfw.com.cn/</a>  <br>
                        太仓市企业服务中心咨询电话：0512-33001717
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div v-if="index==7" class='policyContent'>
            <el-collapse accordion v-model="activeCollapse">
                <el-collapse-item title="（一）园内本科及以上人才入住人才公寓，房租享受“租一免一”优惠。" name="1">
                    <div class='indexBold'>申报条件要求</div>
                    <div>
                        1．园区内企业工作；<br>
                        2．全日制本科及以上毕业生。
                    </div>
                    <div class='indexBold'>办理方式</div>
                    <div>
                      “太易居”APP上申请人才公寓，凭相关材料至大创园11号楼319室办理房租补贴。
                    </div>
                </el-collapse-item>
                <el-collapse-item title="（二）购买指定房源，按本科10万元、硕士20万元、博士30万元给予补贴。" name="2">
                    <div>
                        高新区人社局咨询电话：0512-53568826
                    </div>
                </el-collapse-item>
                <el-collapse-item title="（三）为园内大学生创业人才提供医疗预约、交通出行、文化旅游等生活便利。为园内领军人才、紧缺人才及其他经认定的人才开辟子女入学、医疗保障等绿色通道。" name="3">
                    <div class='indexBold'>办理方式</div>
                    <div>
                        办理平台网址：<a class="linkCss" @click="toNewPage(1)">http://www.taicangqyfw.com.cn/</a> <br>
                        太仓市企业服务中心咨询电话：0512-33001717
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        </div>
    </el-col>
    
  </el-row>
</template>

<script>
export default {
  
  data() {
    return {
      list: [
        {
          name: '加强创业启动扶持',
          list: [
            {
                title: '（一）首次来太落户大创园的大学生创业项目直接给予5万元创业资助。',
                content: 
                    `项目咨询电话：戴先生18962618966、王女士 15250594486;<br>
                    政策咨询电话：0512-53987080`
            },
            {
                title: '(二）落户全国性大学生创新创业大赛获奖项目的，直接按照一等奖50万元、二等奖30万元、三等奖20万元给予创业资助。',
                content: 
                    `项目咨询电话：戴先生18962618966、王女士 15250594486；<br>
                    政策咨询电话：0512-53987080`
            }
          ]
        },
        {
          name: '降低落户创业成本。',
          list: [
            {
                title: '（一）给予大创园新落户大学生创业项目3年场地免租。',
                content: 
                    `创业项目完成注册后，办理入园手续时，签订场地免租合同，咨询电话：0512-53987080`,
                
            },
            {
                title: '（二）录用首次在太就业高校毕业生的，缴纳社保满6个月，按每人3000元标准给予创业带动就业补贴。',
                content: 
                    `<a class="linkCss" :href="JiuYeUrl">{{JiuYeUrl}}</a><br>
                    政策咨询电话:0512-53987080
                    `
            },
            {
                title: '（三）加大大学生创业空间供给，放宽经营场所登记限制，支持更多新业态大学生创业项目入驻。',
                content: 
                    `联系市行政审批局,前台电话0512-53890556; <br>
                    咨询电话：0512-53890525 、0512-53890526
                    `
            }
          ]
        },
        {
          name: '加大创业金融扶持。',
          list: [
            {
                title: '（一）成立3亿元天使投资基金，择优给予落户大学生创业项目最高300万元股权投资。',
                content: 
                    `近期推出相关产品`,
                
            },
            {
                title: '（二）推出“娄城大学生创业贷”政府增信金融产品，提供风险补偿，单个项目贷款最高100万元。',
                content: 
                    `近期推出相关产品
                    `
            },
            {
                title: '（三）加大科技金融补助力度，对企业“苏科贷”“娄城科创贷”等贷款，按实际发放额的5‰给予最高50万元/年贴息补助。',
                content: 
                    `联系中信、宁波、光大银行办理
                    `
            },
             {
                title: '（四）对企业知识产权质押融资，按实际融资额的1%给予最高10万元奖励。/年贴息补助。',
                content: 
                    `联系市市监局咨询办理，电话：0512-53524715
                    `
            }
          ]
        },
         {
          name: '提升就业补贴力度。',
          list: [
            {
                title: '（一）全日制本科及以上毕业生首次来太到大创园实地考察创新创业环境，可享受最高500元考察补贴。',
                content: 
                    `“大创园创业专属考察礼遇”微信小程序上申请`,
                
            },
            {
                title: '（二）全日制本科及以上毕业生首次来太到大创园实地考察创新创业环境，最长15天人才公寓免费住宿。',
                content: 
                    `“大创园创业专属考察礼遇”微信小程序上申请
                    `
            },
            {
                title: '（三）全日制本科及以上在校生在大创园企业见习的，给予1000元/月见习补贴。/年贴息补助。',
                content: 
                    `<a class="linkCss" :href="JianXiUrl">{{JianXiUrl}}</a>;<br>
                    咨询电话：0512-53987080
                    `
            },
             {
                title: '（四）世界前300强高校或“双一流”建设高校（学科）毕业生首次来太入职大创园企业，缴纳社保满6个月，按本科3万元、硕士5万元、博士10万元给予“首年生活补贴”。',
                content: 
                    `<b>办理方式</b></br>
                    登入太仓人才总入口，网址：<a class="linkCss" @click="toNewPage(2)">https://gccrc.tcrc.com.cn/#/</a>，选择“人才计划”再选择“青年人才首年生活补贴”进行申报，咨询电话：0512-53568578、0512-53987080
                    `
            }
          ]
        },
        {
          name: '鼓励企业研发创新。',
          list: [
            {
                title: '（一）园内企业与高校院所开展产学研合作的，按实际发生经费的20%给予最高50万元补助。',
                content: 
                    `<b>办理方式</b><br>
                    联系市科技局咨询办理，电话：0512-53595193
                    `,
                
            },
            {
                title: '（二）园内企业使用江苏省、苏州市科技创新券的，给予最高50万元资助。',
                content: 
                    `<b>办理方式</b><br>
                    联系市科技局咨询办理，电话：0512-53595115
                    `,
            },           
          ]
        },
        {
          name: '支持企业市场推广。',
          list: [
            {
                title: '（一）依托太仓市企业服务总入口，建设大科园供需对接平台，帮助园内企业对接产业链上下游资源，支持优质成果在全市推广应用。%给予最高50万元补助。',
                content: 
                    `<b>办理方式</b><br>
                    办理平台网址：<a class="linkCss" @click="toNewPage(1)">http://www.taicangqyfw.com.cn/</a> <br>
                    太仓市企业服务中心咨询电话：0512-33001717
                    `,
                
            },
            {
                title: '（二）园内企业参加国内外有较高影响力的展会，给予每个标准展位最高2万元，每家企业最高8万元补贴。',
                content: 
                    `<b>办理方式</b><br>
                    联系高新区经发局咨询办理，电话：0512-53595056（国内展会）   <br>
                    电话：0512-53595217（国外展会）
                    `,
            },           
          ]
        },
         {
          name: '拓宽招才引智渠道。',
          list: [
            {
                title: '（一）对新认定为国家级、省级众创空间的，分别给予最高50万元、30万元奖励。%给予最高50万元补助。',
                content: 
                    `<b>办理方式</b><br>
                    联系市科技局咨询办理，电话：0512-53595115
                    `,
                
            },
            {
                title: '（二）鼓励高校院所在大科园设立大学生创新创业实践基地，根据年度绩效任务完成情况，给予不少于30万元奖励。',
                content: 
                    `<b>办理方式</b><br>
                    咨询电话：0512-53987080
                    `,
            },  
            {
                title: '（三）引才组织和个人引荐大学生创业项目入选市级以上领军人才计划的，按人才实缴资本5%给予最高100万元引才奖励。',
                content: 
                    `<b>办理方式</b><br>
                    办理平台网址：<a class="linkCss" @click="toNewPage(1)">http://www.taicangqyfw.com.cn/</a> <br>
                    太仓市企业服务中心咨询电话：0512-33001717
                    `,
            },           
          ]
        },
        {
          name: '完善生活乐居保障。',
          list: [
            {
                title: '（一）园内本科及以上人才入住人才公寓，房租享受“租一免一”优惠。%给予最高50万元补助。',
                content: 
                    `<b>申报条件要求</b><br>
                    1．园区内企业工作；<br>
                    2．全日制本科及以上毕业生。<br>
                    <b>申报条件要求</b><br>
                    “太易居”APP上申请人才公寓，凭相关材料至大创园11号楼319室办理房租补贴。
                    `,
                
            },
            {
                title: '（二）购买指定房源，按本科10万元、硕士20万元、博士30万元给予补贴。',
                content: 
                    `高新区人社局咨询电话：0512-53568826
                    `,
            },  
            {
                title: '为园内大学生创业人才提供医疗预约、交通出行、文化旅游等生活便利。为园内领军人才、紧缺人才及其他经认定的人才开辟子女入学、医疗保障等绿色通道。',
                content: 
                    `<b>办理方式</b><br>
                    办理平台网址：<span class="linkCss" @click="toNewPage(1)">http://www.taicangqyfw.com.cn/</span> <br>
                    太仓市企业服务中心咨询电话：0512-33001717
                    `,
            },           
          ]
        },
      ],
      index: 0,
      activeCollapse: '1',
      urlHpst: window.location.protocol + '//' + window.location.host,
    }
  },
  methods: {
    backtoIndex() {
      this.$router.push({ path: '/solution' })
    },
    activeThis(e) {
        this.activeCollapse = '1'
      console.log(e, 'e')
        document.getElementsByClassName('items')[this.index].classList.remove('active')
      this.index = e;
    //   document.getElementsByClassName('activeContent')[0].innerHTML = this.list[e].content;
        document.getElementsByClassName('items')[e].classList.add('active')
    },
    toNewPage(num) {
        switch(num) {
            case 1: this.$router.push({ name: 'Open', params:{ url: 'http://www.taicangqyfw.com.cn/', lastSocial: true} }); break;
            case 2: this.$router.push({ name: 'Open', params:{ url: 'https://gccrc.tcrc.com.cn/#/', lastSocial: true} }); break;
        }
    },    
    triggerClick(event) {
      console.log("获取标签名="+event.target.className) // 获取标签名
      console.log("获取class属性名="+event.target.nodeName) // 获取class属性名
      console.log("获取id值="+event.target.id) // 获取id值
    }
  },
  mounted() {
    document.getElementsByClassName('items')[0].classList.add('active');
    document.getElementsByName('a').onclick = () => {
        console.log(1111)
    }
  },
  computed: {
    JianXiUrl() {
        return  this.urlHpst + '/#/jianxiForm'
    },
    JiuYeUrl() {
        return  this.urlHpst + '/#/jiuyeForm'
    } ,
    ZuJinUrl() {
        return  this.urlHpst + '/#/zujinForm'
    } ,

  }
}
</script>

<style scoped lang='less'>
.linkCss {
    color: #0000EE;
    text-decoration: underline;
    cursor: pointer;
}
.bacToIndex {
    height: 40px;
    position: absolute;
    margin: 10px 30px;
    background-color: #0c3cb6;
    color: #fff;
    font-weight: bold;
    border-radius: 8px;
//   border: 1px solid red;
    left: 0px;
    top: 0px;
}
.bg {
//   background-image: url('../../assets/busBack2.jpg');
    min-width: 1200px;;
    background-color: #f1f9fc;
    height: 100vh;
    background-size: 100% 100%;
    background-position: center center;
    position: relative;
 .el-col {
    height: 100vh;
    // border: 1px solid green;
 }
 .title {
    writing-mode: vertical-rl;
    font-size: 42px;
    font-weight: bold;
    text-align: center;
    line-height: 5vw;
 }
 .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 34px;
    font-weight: bold;
    line-height: 80px;
 }
.items {
    padding-left: 20px;
    width: 440px;
    // border: 1px solid #427dea;
    cursor: pointer;
    border-radius: 30px;
    height: 65px;
    line-height: 65px;
    margin: 10px;
    background-color: #fff;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-size: 100% 100%;
}
.items:nth-child(2n+1) {
    color: #001E69;
    // box-shadow: 2px 2px 4px #fdc659;
    // border: 5px solid #001e69;
    // border: 5px solid #0c3cb6;
    background-image: url('../../assets/1.png');
}
.items:nth-child(2n).active,
.items:nth-child(2n):hover {
    // background-color: #0c3cb6;
    background-image: url('../../assets/2a.png');
    span {
        color: #fff;
    }
    
}

.items:nth-child(2n) {
    color: #0068b4;
    // box-shadow: 2px 2px 4px #427dea;
    // border: 5px solid #0068b4;
    background-image: url('../../assets/2.png');
}
.items:nth-child(2n+1).active,
.items:nth-child(2n+1):hover {
    // background-color: #0068b4;
    span {
        color: #fff;
    }
    
    background-image: url('../../assets/1a.jpg');
}

.intro {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    .boxPolicy {
        // border: 1px solid rgb(0, 255, 242);
        border-radius: 20px;
        width: 80%;
        box-sizing: border-box;
        overflow: hidden;
    }
    .policyContent {
        // padding: 50px;
        // box-sizing: border-box;
        // height: 100vh;
        // background-size: 100% 100%;
        font-size: 28px;
        display: flex;
        align-items: center;
        // border: 1px solid red;
        .el-collapse {
            width: 100%;
            .el-collapse-item {
                width: 100%;
                .indexBold {
                    font-weight: bold;
                }
            }            
        }        
    }
    img {
        position: absolute;
        bottom: 0;
    }
}
}

</style>
<style lang='less'>
.policyContent {
    .el-collapse-item {
        border-radius: 20px;
    }
    .el-collapse-item__header {
        height: auto !important;
        color: #fff;
        font-weight: bold;
        line-height: 30px;
        padding: 15px;
        font-size: 20px;
    }
    // .el-collapse-item:nth-child(1) .el-collapse-item__header{
    //     background-color: #0068b4;
    // }
    .el-collapse-item__content {
        font-size: 18px;
        padding: 10px 40px;
    }
    .el-collapse-item__header.is-active {
        background-color: #0c3cb6;
    }
    .el-collapse-item__header {
        background-color: #0068b4;
    }
}

</style>

